import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert } from "../../../utils";

export const profileOfferList = createAsyncThunk('profileOfferList', async ({ navigate, shop_id }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: process.env.REACT_APP_API_URL + 'public/' + `offer_banner`,
            params: {
                'shop_id': shop_id
            },
            headers: { "Content-Type": "application/json" }

        })
        return res
    } catch (error) {
        return error.response
    }
})

const profileOfferListSlice = createSlice({
    name: 'profileOfferList',
    initialState: {
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(profileOfferList.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.data = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = [];
            }

        });
        builder.addCase(profileOfferList.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export default profileOfferListSlice.reducer;
